import { Button, Flex, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

type AttendanceSelectionControlsProps = {
  selectedCount: number;
  allSelected: boolean;
  isDisabled: boolean;
  onToggle: () => void;
};

export const AttendanceSelectionControls: React.FC<AttendanceSelectionControlsProps> = ({
  selectedCount,
  allSelected,
  isDisabled,
  onToggle,
}) => {
  const { t } = useTranslation();

  return (
    <Flex align="center" gap={4}>
      {selectedCount > 0 && (
        <Text fontSize="sm" color="gray.600">
          {t('connect.learnersSelectedCount', { count: selectedCount })}
        </Text>
      )}
      <Button variant="outline" size="sm" onClick={onToggle} isDisabled={isDisabled}>
        {allSelected ? t('table.clearSelection') : t('table.selectAll')}
      </Button>
    </Flex>
  );
};
